import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { CURRENCY_0 } from 'commons-vehicle/constants/currencyFormats.js';
import moment from 'moment';

import 'commons-vehicle/Vehicle/components/TradeInOfficialValue/TradeInOfficialValue.scss';

const TradeInOfficialValue = ({ amount, expiration, onTradeInClick, customClassCSS, showIcon }) => {
    const isOfficialAmountExpired = !!expiration && new Date(expiration) <= new Date();

    const vehicleOfficialAmountLabel =
        amount &&
        LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.DEALER_OFFICIAL_VALUE', {
            amount: LocaleService.l(amount, CURRENCY_0),
        });

    const vehicleOfficialAmountExpirationLabel =
        expiration &&
        LocaleService.t('TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.DEALER_OFFICIAL_VALUE_EXPIRATION', {
            date: moment(expiration)
                .locale(LocaleService.getSimpleLocale())
                .format(LocaleService.t('COMMONS_GENERAL.DATE_FORMAT.FULL')),
        });

    let wrapperClassCSS = `transaction-official-value--${isOfficialAmountExpired ? 'expired' : 'valid'}`;
    if (customClassCSS) wrapperClassCSS = `${wrapperClassCSS} ${customClassCSS}`;

    return (
        <div id="transaction-official-value-wrapper" className={wrapperClassCSS}>
            {showIcon && <icon className={`icon-${isOfficialAmountExpired ? 'Warning' : 'Crochet'}`} />}
            <div className="transaction-official-value-text">
                {isOfficialAmountExpired ? (
                    <div>
                        <div>
                            {LocaleService.t(
                                'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.DEALER_OFFICIAL_VALUE_EXPIRED'
                            )}
                        </div>
                        {onTradeInClick && (
                            <button
                                className="sr-button-1 cta-btn"
                                onClick={onTradeInClick}
                                data-test="login.transaction.tradein.official-evaluation-new"
                            >
                                {LocaleService.t(
                                    'TRANSACTION_PROGRESSION.TRANSACTION_ACTION.TRADE_IN.COMPLETE_OFFICIAL.SUBMIT_NEW_ACTION'
                                )}
                            </button>
                        )}
                    </div>
                ) : (
                    <div>
                        <div className="sr-text" dangerouslySetInnerHTML={{ __html: vehicleOfficialAmountLabel }} />
                        {!!expiration && (
                            <div
                                className="sr-text"
                                dangerouslySetInnerHTML={{
                                    __html: vehicleOfficialAmountExpirationLabel,
                                }}
                            />
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

TradeInOfficialValue.defaultProps = {
    customClassCSS: '',
    showIcon: false,
};

TradeInOfficialValue.propTypes = {
    amount: PropTypes.number.isRequired,
    expiration: PropTypes.number.isRequired,
    onTradeInClick: PropTypes.func.isRequired,
    customClassCSS: PropTypes.string,
    showIcon: PropTypes.bool,
};

TradeInOfficialValue.displayName = 'TradeInOfficialValue';

export default TradeInOfficialValue;
